import eventScheduleQuery from '@/services/gql/types/EventSchedules/queries/getEvent.gql'
import eventSeatingQuery from '@/services/gql/types/Seating/queries/getEvent.gql'
import seatRowQuery from '@/services/gql/types/SeatRows/queries/getEvent.gql'
import seatQuery from '@/services/gql/types/Seats/queries/getEvent.gql'
import ticketGroupsQuery from '@/services/gql/types/TicketGroups/queries/getEvent.gql'
import roomQuery from '@/services/gql/types/Rooms/queries/getHotel.gql'
import roomTypeQuery from '@/services/gql/types/RoomTypes/queries/getHotel.gql'
export const queryArray = [
  {
    eventSchedule: [
      {
        query: eventScheduleQuery,
        variables: { eventScheduleId: 'id' },
        result: {
          name: 'page-event',
          params: {
            id: 'eventSchedule.event.id',
            categorySlug: 'eventSchedule.event.slug'
          }
        }
      }
    ],
    timeSlot: [
      {
        query: eventScheduleQuery,
        variables: { eventScheduleId: 'payload.data.eventScheduleId' },
        result: {
          name: 'page-event',
          params: {
            id: 'eventSchedule.event.id',
            categorySlug: 'eventSchedule.event.slug'
          }
        }
      }
    ],
    seating: [
      {
        query: eventSeatingQuery,
        variables: { id: 'payload.id' },
        result: {
          name: 'page-event',
          params: {
            id: 'seating.event.id',
            categorySlug: 'seating.event.slug'
          }
        }
      }
    ],
    seatRow: [
      {
        query: seatRowQuery,
        variables: { id: 'id' },
        result: {
          name: 'page-event',
          params: {
            id: 'seatRows[0].zone.seating.event.id',
            categorySlug: 'seatRows[0].zone.seating.event.slug'
          }
        }
      }
    ],
    seat: [
      {
        query: seatQuery,
        variables: { id: 'id' },
        result: {
          name: 'page-event',
          params: {
            id: 'seats.row.zone.seating.event.id',
            categorySlug: 'seats.row.zone.seating.event.slug'
          }
        }
      }
    ],
    ticketGroup: [
      {
        query: ticketGroupsQuery,
        variables: { id: 'id' },
        result: {
          name: 'page-event',
          params: {
            id: 'ticketGroups[0].event.id',
            categorySlug: 'ticketGroups[0].event.slug'
          }
        }
      }
    ],
    room: [
      {
        query: roomQuery,
        variables: { id: 'id' },
        result: {
          name: 'page-hotel',
          params: { id: 'room.roomType.hotel.id' }
        }
      }
    ],
    roomType: [
      {
        query: roomTypeQuery,
        variables: { id: 'id' },
        result: {
          name: 'page-hotel',
          params: { id: 'roomType.hotel.id' }
        }
      }
    ]
  }
]
